/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import InputListView from '@/views/InputListView';

import tmplAWPackageContractExtensionView from './AWPackageContractExtensionView.hbs';

const AWPackageContractExtensionView = View.extend({
  template: tmplAWPackageContractExtensionView,

  ui: {
    removeContractExtension: '.remove-contract-extension',
    fdrsContainer: '.fdrs-container',
    extensionEndDate: 'input[name="extensionEndDate"]'
  },

  regions: {
    fdrsContainer: '@ui.fdrsContainer'
  },

  triggers: {
    'click @ui.removeContractExtension': 'remove:contract-extension'
  },

  templateContext() {
    return {
      contractExtensionTypes: this.options.contractExtensionTypes,
      editable: this.options.editable
    };
  },

  onRender() {
    this.ui.extensionEndDate.datepicker({ format: 'mm/dd/yyyy' });
    this.ui.extensionEndDate.datepicker('setDate', this.model.get('extensionEndDate'));

    Syphon.deserialize(this, this.model.toJSON());

    this.awPackageContractExtensionFdrs = new InputListView({
      model: new Backbone.Model({
        label: 'Document #s',
        ratio: 'half',
        type: 'text',
        inputName: 'awfdrNum',
        isReadOnly: !this.options.editable
      }),
      collection: new Backbone.Collection(this.model.get('awPackageContractExtensionFdrs'))
    });

    this.showChildView('fdrsContainer', this.awPackageContractExtensionFdrs);
  },

  getFormData() {
    const formData = Syphon.serialize(this);
    formData.awPackageContractExtensionFdrs = this.awPackageContractExtensionFdrs.getFormData();
    return formData;
  }
});

export default AWPackageContractExtensionView;
